import {AbstractControl, type ValidationErrors} from '@angular/forms';

const DOI_PATTERN = /^doi:(10\.\d{4,9}\/[-._;()/:a-zA-Z0-9]+)$/;

export function DoiValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;
  if (!value) return null;
  return DOI_PATTERN.test(value) ? null : {doi: true};
}

export function DoiValidatorMessage(): string {
  return "Invalid DOI format. Acceptable format: 'doi:10.18130/V3/N0H1VA'.";
}
